import React from 'react';
import { View } from 'react-native';
import { Text } from '@shared/components/text';
import { useSoftwareLabel } from '../../hooks/useSoftwareLabel';
import { LabelRow } from './LabelRow';
import {
  CeMarkSymbol,
  DateOfManufactureSymbol,
  EifuSymbol,
  ManufacturerSymbol,
  MdSymbol,
  SnSymbol,
  UdiSymbol,
} from './symbols';

export const UdiSoftwareLabel = () => {
  const { isSoftwareLabelEnabled, softwareLabel } = useSoftwareLabel();

  if (!isSoftwareLabelEnabled) {
    return null;
  }

  return (
    <View className="mt-10 self-start w-full max-w-[360px] border border-black bg-white p-3">
      <View className="flex-row items-start gap-2">
        <View className="items-center gap-1">
          <CeMarkSymbol />
          <Text className="text-xs">{softwareLabel.notifiedBodyNumber}</Text>
        </View>
        <ManufacturerSymbol />
        <View className="flex-1">
          {softwareLabel.manufacturer.map((line, index) => (
            <Text
              key={line}
              className={`text-xs ${index === 0 ? 'font-bold' : ''}`}
            >
              {line}
            </Text>
          ))}
        </View>
        <MdSymbol />
      </View>

      <LabelRow symbol={SnSymbol}>
        <Text className="text-xs">{softwareLabel.serialNumber}</Text>
      </LabelRow>
      <LabelRow symbol={DateOfManufactureSymbol}>
        <Text className="text-xs">{softwareLabel.releaseDate}</Text>
      </LabelRow>
      <LabelRow symbol={UdiSymbol}>
        <Text className="text-xs">{softwareLabel.udiDeviceIdentifier}</Text>
        <Text className="text-xs">{softwareLabel.udiProductionIdentifier}</Text>
      </LabelRow>
      <LabelRow symbol={EifuSymbol}>
        <Text className="text-xs">{softwareLabel.eifuUrl}</Text>
      </LabelRow>
    </View>
  );
};
